import { useEffect, useMemo, useState } from "react";
import { PAGE_SIZES } from "../../CustomerGroups/component/pagination";

/**
 * Busca e paginação na tela, para listas que a API devolve inteiras (histórico e acessos ao CPF do cliente PF).
 * Nova busca ou outro tamanho de página volta para a primeira página; se a lista encolher, a página é ajustada.
 */
export function useLocalTable<T>(items: T[], filter: (items: T[], search: string) => T[]) {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);

  const filtered = useMemo(() => filter(items, search), [filter, items, search]);
  const pageCount = Math.max(1, Math.ceil(filtered.length / pageSize));
  const currentPage = Math.min(page, pageCount);
  const pageItems = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  useEffect(() => {
    setPage(1);
  }, [search, pageSize]);

  return { search, setSearch, filtered, pageItems, page: currentPage, setPage, pageSize, setPageSize };
}
